<template>
  <div class="new_course_editor">
    <div class="new_course_editor_head">
      <span class="el-icon-arrow-left goback" @click="goback"> 返回</span>
      <span>{{courseName}}</span>
      <div class="login-user">
        <el-dropdown @command="handleCommand" :show-timeout="0">
          <div class="user-name el-dropdown-link">
            <div class="imgBox">
              <img :src="imgUrl">
            </div>
            <div class="login-name">{{name}}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logOut">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="new_course_editor_bottom">
      <div class="new_course_editor_tree">
        <new-sidebar
          ref="zlSidebar"
          @setStatus="setStatus"
          :courseId="courseId"
          :subjectId="subjectId"
          @openAddResoures="openAddResoures"
          @emptyCatalogue="emptyCatalogue"
          @handleTreeNodeClick="handleTreeNodeClick"
        ></new-sidebar>
      </div>
      <div class="new_course_editor_content" v-loading="zl_loading">
        <!-- 内容展示 -->
        <!-- <transition name="el-zoom-in-center">
          <div class="new_course_editor_1" v-if="status === 1">
            <new_course_render v-model="resources"></new_course_render>
          </div>
        </transition>-->
        <!-- 内容编辑 -->
        <transition name="el-zoom-in-center" v-if="status === 1">
          <div class="new_course_editor_2">
            <add-resourse :editor="isEditor" :subjectId="subjectId" :data="resources" :catalogue="catalogue" :courseId="courseId" :refresh="refresh"></add-resourse>
          </div>
        </transition>
        <!-- 首次进来展示内容 -->
        <transition name="el-zoom-in-center" v-else>
          <div class="new_course_editor_3">
            <div class="new_course_editor_c">
              <img style=" width:187px;height:159px;margin-bottom: 20px" src="../../../src/assets/image/sources/table_no_data.png" alt="">
              <p style="text-align: center" v-if="status === 0">一级目录下不能编辑内容</p>
              <p style="text-align: center" v-else-if="status === 2">请 <span @click="handleTreeNodeClick(catalogue, 'add')" class="new_course_editor_cc">添加页面</span> 后编辑内容</p>
              <p style="text-align: center" v-else-if="status === 3">请在末级目录下编辑内容</p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
/**
 *  create by wjl at 2021.8.21
 *   新课程编辑模块
 */
import newSidebar from "../component/new_sidebar";
import addResourse from "./components/add_resources";
import new_course_render from "./components/new_course_render";
import * as api from "@/api/courseApi"; // 目录树
export default {
  name: "new_course_editor",
  components: {
    newSidebar,
    addResourse,
    new_course_render,
  },
  data() {
    return {
      courseId: this.$route.query.courseId,
      subjectId: this.$route.query.subjectId,
      courseName: this.$route.query.courseName,
      subjectName: this.$route.query.subjectName,
      type: this.$route.query.type, //课程类型 ，2单项 3综合
      zl_loading: false,
      catalogue: {}, // 选择的目录
      resources: [], // 目录下的资源
      // status
      status: 0,
      refresh: false,
      imgUrl:'../../../static/images/hed0.png',
      name:sessionStorage.getItem('loginName'),
      //
      isEditor: false,
    };
  },
  created() {

  },
  beforeRouteEnter:(to,from,next)=>{
    next((vm)=>{
      if (from.name === 'creatEditor'){
        vm.isEditor = true
      }
    })
  },
  mounted() {
    console.log('--', this.isEditor)

  },
  methods: {
    emptyCatalogue() {
      this.status = 0;
    },
    handleTreeNodeClick(treeData, type) {
     if (treeData.catalogParentId == 0) {
        return this.status = 0;
      }else if(treeData.children && treeData.children.length){
       return this.status = 3;
     }
     else
        if (!treeData.resourceBase || treeData.resourceBase.length == 0) {
            this.catalogue = treeData;
          if (type == "add") {
            this.resources = [{
              tagName: "视频",
              taskType: 1,
              previewType: 0,
            }]
            this.sectionName = "";
            this.status = 1;
            this.refresh = !this.refresh;
          }else{
            return (this.status = 2);
          }
      } else {
        this.zl_loading = true;
        api
          .handleNodeClick(this.courseId, treeData.id)
          .then((res) => {
            if (res.code == 0) {
              if (res.data && res.data.length) {
                [].forEach.call(res.data, (item) => {
                  if (item.type === 6 && item.imageText) {
                    try {
                      let imageText = JSON.parse(item.imageText);
                      this.$set(item, "imageText", imageText);
                    } catch (e) {}
                  }
                });
                this.resources = res.data;
                this.status = 1;
              } else {
                this.resources = [];
                this.sectionName = "";
                this.status = 2;
              }
              this.catalogue = treeData;
              if (type == "add") {
                this.resources.push({
                  tagName: "视频",
                  taskType: 1,
                  previewType: 0,
                })
                this.sectionName = "";
                this.status = 1;
              }
              this.refresh = !this.refresh;
            } else {
                this.$message.warning(res.msg);
            }
          })
          .finally(() => {
            this.zl_loading = false;
          })
          .catch((error) => {
            this.$messageError(error);
          });
      }
    },
    setStatus(n) {
      // 初始化
      this.status = n;
      this.catalogue = {};
      this.resources = [];
    },
    openAddResoures(chapter, catalogue, from) {
      if (from === "add") {
        this.setStatus(2);
      } else {
        this.sectionName = catalogue.catalogName;
        this.status = 2;
      }
      this.addType = chapter.type;
      if (this.addType == 6 && chapter.imageText) {
        this.questionConfigure = chapter.imageText;
      }
      this.catalogue = catalogue;
    },
    goback() {
      // this.$router.go(-1);
      this.$router.replace({
        // path: "/n-EditCourse",
        path: "/courseEditPage",
        query: {
          id: this.courseId,
          subjectId: this.subjectId,
          courseName: this.courseName,
          subjectName: this.subjectName,
          curId: 0,
          courseModel: this.$route.query.courseModel
        }
      })
    },
    handleCommand(command){
      if(command == 'logOut'){
        this.$logOut()
      }
    },
  },
};
</script>

<style scoped lang="scss">
.new_course_editor {
  width: 100%;
  height: 100%;
  min-width: 900px;
  overflow: hidden;
  font-size: 13px;
  user-select: none;
  background: #f5f5f7;

  .new_course_editor_head {
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    background: #0E56AD;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    .goback {
      font-size: 17px;
      cursor: pointer;
    }
    .zl-header-img {
      width: 40px;
      height: 40px;
      border-radius: 40px;
    }
  }
  .new_course_editor_bottom {
    height: calc(100% - 50px);
    width: 1366px;
    margin: 0 auto;
    display: flex;
  }
  .new_course_editor_tree {
    margin: 1% 0;
    margin-left: 45px;
    width: 240px;
    background: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  .new_course_editor_content {
    flex: 1;
    margin: 1% 20px;
    border-radius: 4px;
    overflow: hidden;
    .new_course_editor_1 {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
    }
    .new_course_editor_2 {
      width: 100%;
      height: 100%;
      overflow: hidden;
      /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
    }

    /* 当状态为3，初始页面 */
    .new_course_editor_3 {
      width: 100%;
      height: 100%;
      position: relative;
      .new_course_editor_c {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        p {
          padding: 6px 0;
          font-size: 15px;
          color: #999999;
        }
        .new_course_editor_cc{
          color: #0e9aff;
          cursor: pointer;
        }
      }
    }
  }
  .login-user {
    position: relative;
    cursor: pointer;
    .login-name {
      margin-left: 6px;
      color: #ffffff;
      line-height: 20px;
    }
    .user-name {
      height: 100%;
      display: flex;
      align-items: center;
      .imgBox {
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #333;
        border-radius: 50%;
        img{
          height: 100%;
        }
      }
    }
    .el-dropdown {
      margin-right: 32px;
    }
    &:hover{
      .login-name {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/new_course_editor/index.vue